import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PillTab from './PillTab'

class PillTabs extends Component {

    static defaultProps = {
        items: [],
        current: null
    }

    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.any
            })
        ),
        current: PropTypes.any
    }

    constructor(props) {
        super(props)

        this.state = {
            current: props.current || props.items[0] && props.items[0].value
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.current !== nextProps.current) {
            this.setState({
                current: nextProps.current
            })
        }
    }

    handleClick(value) {
        this.setState({
            current: value
        }, () => {
            if (this.props.onChange) {
                this.props.onChange(value)
            }
        })
    }

    render() {
        const { items } = this.props
        
        return (
            <div className="PillTabs">
                {items.map((item, index) => (
                    <PillTab
                        label={item.label}
                        key={index}
                        active={this.state.current === item.value}
                        onClick={() => this.handleClick(item.value)} />
                ))}
            </div>
        )
    }
}

export default PillTabs;


// WEBPACK FOOTER //
// ./components/PillTabs.js